import { createSlotRecipe } from './runtime';

const signaturePadConfig = {"name":"signaturePad","slots":["root","control","segment","segmentPath","guide","clearTrigger","label"]}

export const signaturePad = /* @__PURE__ */ createSlotRecipe(signaturePadConfig)